// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__2Lys3","list":"styles_list__3_T4L"};